// extracted by mini-css-extract-plugin
module.exports =  {"readMoreButton":"ReadMore-module__readMoreButton--fYZZr"};